<template>
  <div class="home-copyright">
    <div class="text">Copyright © 2006-2020 永辉超市版权所有 备案号：闽ICP备05003392号-1</div>
  </div>
</template>

<script>
export default {
  name: "HomeCopyright"
};
</script>

<style lang="scss" scoped>
.home-copyright {
  width: 100%;
  margin: 30px auto;
  .text {
    text-align: center;
    color: #6d7278;
  }
}
</style>